import React from "react";
import PerformancePage from "./HR/Performance/Performance";

export default function PerformancePageWrapper() {
  return (
    <div className="px-6 space-y-6 animate-in fade-in duration-300">
      <PerformancePage />
    </div>
  );
}
